"use client";

import React from "react";
import BrandsSliderSection from "../components/BrandsSliderSection";
import HeroSection from "../components/HeroSection";
import ServicesCardSection from "../sections/game-development/GameDevelopmentServicesCardSection";
import TechSlider from "../sections/game-development/TechSliderSection";
import Platforms from "../sections/game-development/PlatformsSection";
import ProjectsShowcase from "../components/ProjectsShowcase";
import TechStackTabs from "../components/TechStackTabs";
import WhyChoose from "../components/WhyChoose";
import ExtraSectionsDispatcher from "../components/ExtraSectionsDispatcher";
import { useServiceData } from "../hooks/useServiceData";
import GameGenres from "../sections/game-development/GameGenres";

export default function GameDevelopmentClient() {
  const { data: backendData } = useServiceData();
  const extraSections = backendData?.extraSections || [];
  const gameGridData = extraSections.find(s => s.type === 'gamesGridSection')?.refId;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Game Development Services",
    serviceType: "Game Development",
    provider: { "@type": "Organization", name: "CodeQlik" },
    areaServed: "Global",
    description:
      "Full‑cycle game development: concept, gameplay, art, multiplayer, monetization, live ops, and cross‑platform delivery (PC/Mobile/Web).",
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      {/* Hero section */}
      <HeroSection />
      {/* Brands slider */}
      <BrandsSliderSection />
      {/* Service cards */}
      <ServicesCardSection />
      {/* TechSlider section */}
      <TechSlider />
      {/* Platform section */}
      <Platforms />
      
      {/* Game Genres (Dynamic with Static Fallback) */}
      <GameGenres dynamicData={gameGridData} />
      
      {/* Projects section */}
      <ProjectsShowcase />
      {/* TechStackTabs section */}
      <TechStackTabs />
      {/* WhyChoose Section */}
      <WhyChoose />
    </>
  );
}
